export default __webpack_public_path__ + "static/media/4G.e7f0c39e.png";